module.exports = __webpack_public_path__ + "img/mail-active.af8db99f.svg";